import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import type { AppConfig } from '../config';

/**
 * Cognito managed login via auth-code + PKCE (public client, no secret).
 * Endpoints are set explicitly (rather than discovered) so the custom domain
 * auth.forms.knocking.com is used consistently. Tokens live in sessionStorage
 * — never localStorage.
 */
export function createUserManager(cfg: AppConfig): UserManager {
  return new UserManager({
    authority: cfg.issuer,
    metadata: {
      issuer: cfg.issuer,
      authorization_endpoint: `${cfg.hostedUiBase}/oauth2/authorize`,
      token_endpoint: `${cfg.hostedUiBase}/oauth2/token`,
      userinfo_endpoint: `${cfg.hostedUiBase}/oauth2/userInfo`,
      end_session_endpoint: `${cfg.hostedUiBase}/logout`,
      revocation_endpoint: `${cfg.hostedUiBase}/oauth2/revoke`,
    },
    client_id: cfg.clientId,
    redirect_uri: `${window.location.origin}/auth/callback`,
    post_logout_redirect_uri: `${window.location.origin}/`,
    response_type: 'code',
    scope: 'openid email profile',
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    revokeTokenTypes: ['refresh_token'],
    revokeTokensOnSignout: true,
  });
}
